import React from 'react'
import {
  Label,
  Popup
} from 'semantic-ui-react'

// Empty colored circle (or nothing) per enum
// (color or absence of circle depends on item's choice for that enum)
const ItemCircle = ({item, type}) => {
  //console.log("ItemCircle::render()", item, type);
  if (!item) {
    return null;
  }
  return (
    type.map((e,ei)=>{
      let choice = e.choices.find(c=>c.id===item[e.id]);
      return (
        <span key={ei} style={{marginRight: '8px'}}>
          {
            choice
            ?
            <Popup
              trigger={
                <Label empty circular color={choice.color}/>
              }
              content={
                <div>
                  <strong>{e.name}:</strong> {choice.name}
                  <p style={{fontSize: '80%'}}>
                    <span style={{color: 'grey'}}>{choice.description}</span>
                  </p>
                </div>
              }
            />
            :
            null
          }
        </span>
      );
    })
  );
}

export default ItemCircle